<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset1"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span class="reset" v-preventReClick @click="reset1">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <!-- <el-table-column type="selection" fixed align="center" width="55"></el-table-column> -->
        <el-table-column prop="priceMonitorId" label="平台产品id" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorRegProcurecatalogId" width="100" label="商品流水号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorProductName" label="目录名称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorRegCername" label="注册证名称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorOutLookc" label="平台规格" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorModel" label="平台型号" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorCompanyNameSc" label="平台生产企业" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorCompanyIdPs" label="平台配送商编码" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorCompanyNamePs" label="平台配送商" width="120" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="priceMonitorCalUnit" label="计量单位" width="80" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="priceMonitorPrice" label="平台采购价格" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorNineState" label="九段线状态" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorBidPrice" label="挂网现价/中选价" width="130" show-overflow-tooltip></el-table-column>

        <el-table-column prop="no" label="医院目录编码" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="医院产品名称" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" label="医院规格型号" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" label="医院生产企业" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierNo" label="医院供应商编码" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName" label="医院供应商名称" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchasePrice" label="医院采购价" width="100"></el-table-column>
        <el-table-column prop="lowInPrice" label="最低价" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productCode" label="商品代码" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newProductId" label="产品Id" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="onlineNo" label="挂网号" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newOnlineNo" label="新挂网号" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorPriceStateName" label="价格状态" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stateName" label="启用状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.isEnabled == 1,
                forbidden: scope.row.isEnabled == 0,
              }">{{ scope.row.isEnabledName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorCompareStateName" width="100" label="是否对照" show-overflow-tooltip></el-table-column>
        <el-table-column prop="compareTime" width="170" label="最近更新时间" show-overflow-tooltip>
          <template slot-scope="scope">{{ parseTime(new Date(scope.row.compareTime)) }}</template>
        </el-table-column>
        <el-table-column prop="compareUserNo" label="对照人员编码" width="110"></el-table-column>
        <el-table-column prop="compareUserName" label="对照人员" width="100"></el-table-column>
        <el-table-column prop="operation" fixed="right" width="130" label="操作">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Compare') != -1" type="text" v-preventReClick @click="showCompareDialog(scope.row)" class="color-blue">对照</el-button>
            <el-button v-if="tableAcl.indexOf('CancelCompare') != -1 && scope.row.priceMonitorCompareState == 1" type="text" v-preventReClick @click="cancelCompare(scope.row)" class="margin-left20 color-blue">取消对照</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="对照常用产品目录信息" :visible.sync="compareDialogVisible" width="80%">
      <el-form ref="compareQueryForm" :model="compareQueryForm" label-width="85px">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="goodsId" label="产品id">
              <el-input v-model="compareQueryForm.goodsId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="productName" label="目录名称">
              <el-input v-model="compareQueryForm.productName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="regCername" label="注册证名称">
              <el-input v-model="compareQueryForm.regCername"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="model" label="规格型号">
              <el-input v-model="compareQueryForm.model"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="companyNameSc" label="生产企业">
              <el-input v-model="compareQueryForm.companyNameSc"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="companyIdPs" label="配送商编码">
              <el-input v-model="compareQueryForm.companyIdPs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="companyNamePs" label="配送商">
              <el-input v-model="compareQueryForm.companyNamePs"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="price" label="采购价格">
              <el-input-number :controls="false" v-model="compareQueryForm.price" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="ybCode" label="医保代码">
              <el-input v-model="compareQueryForm.ybCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <!-- <el-form-item> -->
            <el-button type="primary" @click="getCompareList">查 询</el-button>
            <el-button @click="compareQueryReset">重 置</el-button>
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>

      <el-table ref="multipleTable" border row-key="id" :data="compareDatas" :max-height="tableHeight" style="width: 100%;min-height:436px;margin-top:10px" @selection-change="compareSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" style="height:300px">
            <img src="../../../../assets/noData.png" width="150" height="150" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="compareQueryReset">恢复默认</div>
          </div>
        </template>
        <el-table-column type="selection" :reserve-selection="true" fixed align="center" width="55"></el-table-column>
        <el-table-column prop="goodsId" min-width="110" label="产品ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" min-width="120" label="目录名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regCername" min-width="120" label="注册证名称" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="outLookc" min-width="120" label="规格" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="model" min-width="120" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNameSc" min-width="140" label="生产企业" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyIdPs" min-width="140" label="配送商编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNamePs" min-width="140" label="配送商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" min-width="80" label="采购价格" show-overflow-tooltip></el-table-column>

        <el-table-column prop="lastUpdateTime" min-width="160" label="最后修改日期" show-overflow-tooltip>
          <template slot-scope="scope">{{ parseTime(new Date(scope.row.lastUpdateTime)) }}</template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :current-page="compareQueryForm.pageIndex" :total="compareTotal" @current-change="compareChangePage">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="compareMultiple" @click="compare">确 定</el-button>
        <el-button @click="compareDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetSupplierProducts,
  GetGoods,
  CompareGoodAndSupplierProduct,
  CancelSupplierProductCompare,
  ExportSupplierProductCompare
} from "@/api";
import {
  PriceMonitorCompanyTypeOptions,
  WhetherOptions,
  PriceMonitorCompareStateOptions,
  PriceMonitorPriceStateOptions
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin";
import GetSpdDataMixin from "@/mixin/getData-spd-mixin";
import BaseListMixin from '@/mixin/baseList-mixin.js'
import SelectFilter from "@/components/table-select-filter";

export default {
  components: {
    SelectFilter
  },
  mixins: [GetDataMixin, GetSpdDataMixin, BaseListMixin],
  data () {
    return {
      exportAction: ExportSupplierProductCompare,
      GetDatasAction: GetSupplierProducts,

      PriceMonitorCompanyTypeOptions: PriceMonitorCompanyTypeOptions,
      WhetherOptions: WhetherOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,

      PriceMonitorPriceStateOptions: PriceMonitorPriceStateOptions,
      filterOptions: [
        {
          name: "平台产品id",
          type: "input",
          code: "priceMonitorGoodsId"
        },
        {
          name: "目录名称",
          type: "input",
          code: "priceMonitorProductName"
        },
        // {
        //   name: "平台规格",
        //   type: "input",
        //   code: "priceMonitorOutLookc"
        // },
        {
          name: "平台产品规格型号",
          type: "input",
          code: "priceMonitorModel"
        },
        {
          name: "平台生产企业",
          type: "input",
          code: "priceMonitorCompanyNameSc"
        },
        {
          name: "平台配送商",
          type: "input",
          code: "priceMonitorCompanyNamePs"
        },
        {
          name: "医院目录编码",
          type: "input",
          code: "no"
        },
        {
          name: "医院产品名称",
          type: "input",
          code: "productName"
        },
        {
          name: "医院规格型号",
          type: "input",
          code: "specName"
        },
        // {
        //   name: "挂网号",
        //   type: "input",
        //   code: "onlineNo"
        // },
        {
          name: "医院生产企业",
          type: "input",
          code: "manufacturerName"
        },
        {
          name: "医院供应商编码",
          type: "input",
          code: "supplierNo"
        },
        {
          name: "医院供应商名称",
          type: "input",
          code: "supplierName"
        },
        // {
        //   name: "商品代码",
        //   type: "input",
        //   code: "productCode"
        // },
        {
          name: "医院产品id",
          type: "input",
          code: "newProductId"
        },
        // {
        //   name: "医院采购价",
        //   type: "number",
        //   code: "purchasePrice"
        // },
        {
          name: "启用状态",
          type: "select",
          code: "isEnabled",
          data: WhetherOptions
        },
        {
          name: "对照状态",
          type: "select",
          code: "priceMonitorCompareState",
          data: PriceMonitorCompareStateOptions
        },
        {
          name: "价格状态",
          type: "select",
          code: "priceMonitorPriceState",
          data: PriceMonitorPriceStateOptions
        },
      ],

      supplierProductId: "",
      compareDialogVisible: false,
      compareQueryForm: {
        pageSize: 10,
        pageIndex: 1,
        goodsId: '',
        regCername: '',
        productName: '',
        model: '',
        companyNameSc: '',
        companyIdPs: '',
        companyNamePs: '',
        price: undefined,
      },
      compareDatas: [],
      compareSelection: [],
      compareMultiple: true,
      compareTotal: 0,
    };
  },
  methods: {
    showCompareDialog (row) {
      this.compareDialogVisible = true
      this.supplierProductId = row.id
      this.compareQueryReset()
    },
    compare () {
      var goodsId = this.compareSelection[0].id
      CompareGoodAndSupplierProduct({ supplierProductId: this.supplierProductId, goodsId: goodsId })
        .then(res => {
          this.$my_message(`对照成功`, 'success')
          this.compareDialogVisible = false
          this.supplierProductId = ''
          this.getData()
        })
    },
    cancelCompare (row) {
      this.$confirm('提示', { title: '提示', type: 'warning', message: "确定要取消这条常用产品目录的对照吗？" })
        .then(() => {
          return CancelSupplierProductCompare({ supplierProductId: row.id })
        })
        .then(res => {
          this.$my_message(`取消对照成功`, 'success')
          this.getData()
        })
    },
    getCompareList () {
      GetGoods(this.compareQueryForm)
        .then(res => {
          this.compareDatas = res.returnData.data;
          this.compareTotal = res.returnData.totalCount;
        })
    },
    compareQueryReset () {
      this.compareQueryForm = {
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        goodsId: '',
        regCername: '',
        outLookc: '',
        model: '',
        companyNameSc: '',
        companyIdPs: '',
        companyNamePs: '',
        price: undefined,
      }
      console.log(this.compareQueryForm)

      this.getCompareList()
    },
    compareChangePage (val) {
      this.$set(this.compareQueryForm, "pageIndex", val);
      this.getCompareList();
    },
    compareSelectionChange (selection) {
      this.compareSelection = selection
      this.compareMultiple = !(selection.length == 1);
    },

    // 重置
    reset1 () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
  },
  created () {
    this.query.priceMonitorType = 1 // 只显示耗材
  },
  mounted () {
  },
};
</script>

<style lang="scss" scoped></style>
